import { isString } from 'lodash';
import React from 'react';
import { app as api } from '@ekuaibao/whispered';
import { getStaffName } from './utilFn';
import { getStaffShowExternal } from './utilFn';
import { NameCell } from './name-cell';
var handleSomeSpecialData = function (staffObj) {
    if (staffObj === void 0) { staffObj = {}; }
    var name = staffObj.id !== 'departmentsIncludeChildren' ? React.createElement(NameCell, { type: "user", id: staffObj.id, name: staffObj.name }) : getStaffName(staffObj);
    if (!name)
        return '';
    var str = getStaffShowExternal(staffObj);
    if (str) {
        return React.createElement(React.Fragment, null,
            name,
            str);
    }
    return name;
};
var isMayRoleData = function (obj) {
    var _a;
    if (obj === void 0) { obj = {}; }
    return obj.type === 'ROLE' || obj.dimensionId || ((_a = obj.dataType) === null || _a === void 0 ? void 0 : _a.startsWith('basedata.Dimension.'));
};
export var getStaffShowByConfig = function (value) {
    var _a;
    if (!value) {
        return value;
    }
    var staffObj = value;
    if (isString(value)) {
        var staffMap = ((_a = api === null || api === void 0 ? void 0 : api.getState()['@common']) === null || _a === void 0 ? void 0 : _a.allStaffActiveStaffMap) || {};
        staffObj = staffMap[value];
    }
    if (window.isInWeComISV && !isMayRoleData(staffObj)) {
        return handleSomeSpecialData(staffObj);
    }
    var name = getStaffName(staffObj);
    if (!name)
        return '';
    var str = getStaffShowExternal(staffObj);
    return str ? "" + name + str : name;
};
